import React from 'react';

import ImageGallery from 'react-image-gallery';

import 'react-image-gallery/styles/css/image-gallery.css';
import './ImageGalleryWrapper.css';

const images = [
  {
    original: 'images/01_dialog.jpg',
  },
  {
    original: 'images/02_dialog.jpg',
  },
  {
    original: 'images/03_dialog.jpg',
  },
  {
    original: 'images/04_dialog.jpg',
  },
];

const ImageGalleryWrapper = React.forwardRef((props, ref) => {
  const { additionalClass, ...rest } = props;
  const additionalClassValue =
    additionalClass === undefined ? 'bullet' : `bullet ${additionalClass}`;

  return (
    <ImageGallery
      items={images}
      showFullscreenButton={false}
      showPlayButton={false}
      showNav={true}
      infinite={true}
      showBullets={true}
      additionalClass={additionalClassValue}
      showThumbnails={false}
      autoPlay={true}
      slideInterval={5000}
      ref={ref}
      {...rest}
    />
  );
});

export const ImageGalleryContent = ({ imageIndex }) => {
  switch (imageIndex) {
    case 0:
      return <>タクシー代、弁当代、カラオケ代など複数の伝票を集計します。</>;
    case 1:
      return <>Aさんがタクシー代、Bさんが弁当代、Cさんがカラオケ代を別々に支払っても大丈夫です。</>;
    case 2:
      return (
        <>
          Bさんは売店で弁当を買ったら忘れないうちにその場で伝票を登録できます。
          登録した内容はネットを介して瞬時に全員の精算表に反映されます。
        </>
      );

    case 3:
      return (
        <>
          カラオケ代8,000円の支払いを、AさんとBさんは3,000円、Cさんは2,000円のように金額を調整できます。
        </>
      );
    default:
      return null;
  }
};

export default ImageGalleryWrapper;
